import { useRoutes } from '@/shared/routes';

export const headRoutes = [
  {
    path: useRoutes.HEAD_LIST_PATH,
    name: useRoutes.HEAD_LIST_NAME,
    component: () => import('@/pages/RegisterChapters'),
  },
  {
    path: useRoutes.HEAD_ITEM_PATH,
    name: useRoutes.HEAD_ITEM_NAME,
    component: () => import('@/pages/ChapterInformation'),
  },
  {
    path: useRoutes.CURRENT_PATH,
    name: useRoutes.CURRENT_NAME,
    component: () => import('@/pages/Current'),
  },
];
